import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default function providerDataReducer(state = initialState.providerData, action) {
    switch (action.type) {
        case types.PROVIDERS_LOADED:
            return { ...state, ...action.providerData };
        default:
            return state;
    }
}
